<script>
import OssStatistik from '@/components/dashboard/oss/Statistik.vue'
import OssNibPerBulan from '@/components/dashboard/oss/NibPerBulan.vue'
import OssNibPerKecamatan from '@/components/dashboard/oss/NibPerKecamatan.vue'
import OssNibPerSkalaUsaha from '@/components/dashboard/oss/NibPerSkalaUsaha.vue'
import OssNibPerStatusPenanamanModal from '@/components/dashboard/oss/NibPerStatusPenanamanModal.vue'
import OssNibPerJenisPerusahaan from '@/components/dashboard/oss/NibPerJenisPerusahaan.vue'
import OssTopKbli from '@/components/dashboard/oss/KbliTop.vue'
import OssKbliPerSkalaUsaha from '@/components/dashboard/oss/KbliPerSkalaUsaha.vue'
import OssKbliPerRisiko from '@/components/dashboard/oss/KbliPerRisiko.vue'
import OssKbliPerSektor from '@/components/dashboard/oss/KbliPerSektor.vue'

export default {
   components: {
      OssStatistik,
      OssNibPerBulan,
      OssNibPerKecamatan,
      OssNibPerSkalaUsaha,
      OssNibPerStatusPenanamanModal,
      OssNibPerJenisPerusahaan,
      OssTopKbli,
      OssKbliPerSkalaUsaha,
      OssKbliPerRisiko,
      OssKbliPerSektor,
   },
}
</script>

<template>
   <div>
      <OssStatistik />
      <OssNibPerBulan />
      <OssNibPerKecamatan />
      <b-row>
         <b-col cols="12" md="12" lg="6">
            <OssNibPerSkalaUsaha />
         </b-col>
         <b-col cols="12" md="12" lg="6">
            <OssNibPerStatusPenanamanModal />
         </b-col>
      </b-row>

      <b-row>
         <b-col cols="12" md="12" lg="6">
            <OssKbliPerSkalaUsaha />
         </b-col>
         <b-col cols="12" md="12" lg="6">
            <OssKbliPerRisiko />
         </b-col>
      </b-row>
      <OssTopKbli />
      <OssNibPerJenisPerusahaan />
      <OssKbliPerSektor />
   </div>
</template>

<style scoped></style>
